/* ============================================================================
   FRONT LINE DEV - DO NOT EDIT
   This file powers Infinit's custom Quiz and Custom Formula functionality and
   is maintained exclusively by Front Line Dev. Editing it may break the
   formula builder, quiz, saved formulas, or related features. Please contact
   Front Line Dev for any changes.
   ============================================================================ */

/**
 * Formula Edit Mode
 *
 * When a customer clicks "Edit" on the My Formulas page, they are redirected to
 * the Custom Hydration/Protein builder page with ?edit=1&formula_id=X&formula_name=Y
 * and the formula config encoded in the URL hash.
 *
 * This script detects edit mode and modifies the page:
 *  - Shows "EDITING: [FORMULA NAME]" banner at the top
 *  - Hides the formula name text box (NAME YOUR BLEND section)
 *  - Hides the subscription section (SUBSCRIBE & SAVE)
 *  - Replaces "Add to Cart" button with "Save Formula" button
 *  - Keeps the "Talk to an Expert" button
 *  - Save Formula posts the updated config back to the API
 */
(function () {
  "use strict";

  const params = new URLSearchParams(window.location.search);
  const isEditMode = params.get("edit") === "1";
  if (!isEditMode) return;

  const formulaId = params.get("formula_id");
  const formulaName = params.get("formula_name") || "Custom Formula";
  const isAdminContext = params.get("admin") === "1";

  if (!formulaId) return;

  // Inject CSS immediately (before DOM ready) to prevent flash of hidden elements
  var earlyStyle = document.createElement("style");
  earlyStyle.textContent = [
    // Hide header/logo bar
    "header, .header, #shopify-section-header, .shopify-section-group-header-group, [class*='header-section'], .section-header { display: none !important; }",
    // Hide announcement bar
    ".announcement-bar, .shopify-section-announcement-bar, [class*='announcement'] { display: none !important; }",
    // Hide product media/images column
    ".product-media, .product__media-wrapper, .product-media-container, .media-gallery { display: none !important; }",
    // Hide image banner / hero
    "[class*='shopify-section'][id*='image-banner'], [class*='shopify-section'][id*='image_banner'] { display: none !important; }",
    // Hide reviews
    ".jdgm-widget, .jdgm-preview-badge, [data-judgeme-widget], .jdgm-carousel-wrapper, .jdgm-rev-widg { display: none !important; }",
    // Make product layout full width since we're hiding the media column
    ".product-layout--large .product-info, .product-layout--medium .product-info { width: 100% !important; max-width: 100% !important; flex: 1 !important; }",
    ".md\\:flex.justify-center { display: block !important; }",
    // Hide variant picker and buy-buttons in main-product (edit mode has Save button)
    ".product-info__block--buy-buttons, .product-info .shopify-payment-button { display: none !important; }",
  ].join("\n");
  (document.head || document.documentElement).appendChild(earlyStyle);

  // Detect page type
  const isProtein =
    window.location.pathname.includes("custom-protein") ||
    document.querySelector('[data-product-type="protein"]') !== null;
  const pageType = isProtein ? "protein" : "hydration";

  // Wait for DOM ready
  function onReady(fn) {
    if (document.readyState !== "loading") {
      setTimeout(fn, 300);
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        setTimeout(fn, 300);
      });
    }
  }

  onReady(function () {
    insertEditBanner();
    hideHeroImage();
    hideNameSection();
    hideSubscriptionSection();
    hideHeroButtons();
    hideProductMedia();
    hideExtraMainProductBlocks();
    replaceAddToCartWithSave();
  });

  // Mutable formula name — updated by the edit banner input
  let editableFormulaName = formulaName;

  function insertEditBanner() {
    // Insert at the top of the product content area
    const banner = document.createElement("div");
    banner.style.cssText =
      "background:#222;color:#f2d500;padding:14px 24px;font-size:18px;font-weight:700;text-align:center;text-transform:uppercase;letter-spacing:0.05em;position:relative;z-index:100;";

    const label = document.createElement("span");
    label.textContent = "Edit Formula Name: ";

    const nameInput = document.createElement("input");
    nameInput.type = "text";
    nameInput.id = "edit-formula-name";
    nameInput.value = formulaName;
    nameInput.style.cssText =
      "background:#333;color:#f2d500;border:1px solid #555;border-radius:4px;padding:4px 10px;font-size:18px;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;width:auto;min-width:200px;max-width:60%;text-align:center;outline:none;";
    nameInput.addEventListener("input", function () {
      editableFormulaName = nameInput.value.trim() || formulaName;
    });
    nameInput.addEventListener("focus", function () {
      nameInput.style.borderColor = "#f2d500";
    });
    nameInput.addEventListener("blur", function () {
      nameInput.style.borderColor = "#555";
    });

    banner.appendChild(label);
    banner.appendChild(nameInput);

    // Try to insert after the header / before the product content
    const mainContent =
      document.querySelector(".product-page") ||
      document.querySelector("main") ||
      document.querySelector("#MainContent") ||
      document.querySelector(".shopify-section:nth-child(2)");

    if (mainContent) {
      mainContent.parentNode.insertBefore(banner, mainContent);
    } else {
      document.body.insertBefore(banner, document.body.firstChild);
    }
  }

  function hideHeroImage() {
    // Hide the image-banner section by matching section ID pattern
    // Shopify JSON templates generate IDs like "shopify-section-template--*--image_banner_*"
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      var id = sec.id || '';
      // Match by section ID containing image-banner or image_banner
      if (id.includes('image-banner') || id.includes('image_banner')) {
        sec.style.display = 'none';
        return;
      }
      // Match sections whose only child is a banner (not product sections that happen to contain a .banner class)
      var type = sec.getAttribute('data-section-type') || '';
      if (type === 'image-banner' || type === 'hero-banner') {
        sec.style.display = 'none';
      }
    });
  }

  function hideReviews() {
    // Hide Judge.me review sections — but skip sections that contain boosts
    // or product-info (main product section may have auto-injected badges).
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      if (sec.querySelector('[data-ch-boosts], .custom-hydration-boosts, .custom-protein-boosts, .product-info')) return;
      var id = sec.id || '';
      if (id.includes('judge') || id.includes('review') ||
          sec.querySelector('[data-judgeme-widget], .jdgm-widget, .jdgm-review-widget, .jdgm-carousel, [class*="judge-me"], [class*="judgeme"]')) {
        sec.style.display = 'none';
      }
    });
    // Also hide inline Judge.me badges and widgets
    document.querySelectorAll('.jdgm-widget, .jdgm-preview-badge, [data-judgeme-widget], .jdgm-carousel-wrapper, .jdgm-rev-widg').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function hideProductMedia() {
    // Hide the product images/media column (CSS handles the initial hide,
    // this catches anything the CSS selectors might miss)
    document.querySelectorAll('.product-media, .product__media-wrapper, .product-media-container, .media-gallery').forEach(function (el) {
      el.style.display = 'none';
    });
    // Hide review sections — but NOT sections that also contain boost blocks
    // or product-info (the main product section may contain both Judge.me
    // badges and boost checkboxes; hiding the whole section kills boosts).
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      if (sec.querySelector('[data-ch-boosts], .custom-hydration-boosts, .custom-protein-boosts, .product-info')) return;
      if (sec.querySelector('[data-judgeme-widget], .jdgm-widget, .jdgm-review-widget, .jdgm-carousel')) {
        sec.style.display = 'none';
      }
    });
  }

  function hideNameSection() {
    // Hide "NAME YOUR BLEND" block.
    // IMPORTANT: Only hide the immediate .product-info__block wrapper, NOT
    // broader ancestors like [data-cc-animate] which is the entire product-info
    // container (that also holds boosts, buy-buttons, etc.).
    const headings = document.querySelectorAll("h2, h3, .section__heading");
    headings.forEach(function (h) {
      const text = (h.textContent || "").trim().toUpperCase();
      if (text.includes("NAME YOUR BLEND") || text.includes("NAME YOUR MIX")) {
        var block = h.closest(".product-info__block") || h.closest(".product-block") || h.parentElement;
        if (block) block.style.display = "none";
      }
    });

    // Also try to hide by input name
    const blendNameInput = document.querySelector(
      'input[name="properties[Blend name]"], input[name="properties[Mix Name]"]'
    );
    if (blendNameInput) {
      var block = blendNameInput.closest(".product-info__block") || blendNameInput.closest(".product-block") || blendNameInput.closest(".field");
      if (block) block.style.display = "none";
    }
  }

  function hideSubscriptionSection() {
    // Hide "SUBSCRIBE & SAVE" block.
    // IMPORTANT: Only hide the immediate .product-info__block wrapper, NOT
    // broader ancestors like [data-cc-animate] which is the entire product-info
    // container (that also holds boosts, buy-buttons, etc.).
    const headings = document.querySelectorAll("h2, h3, .section__heading");
    headings.forEach(function (h) {
      const text = (h.textContent || "").trim().toUpperCase();
      if (text.includes("SUBSCRIBE") && text.includes("SAVE")) {
        var block = h.closest(".product-info__block") || h.closest(".product-block") || h.parentElement;
        if (block) block.style.display = "none";
      }
    });

    // Also hide selling plan radio buttons
    const sellingPlanInputs = document.querySelectorAll(
      '[name="selling_plan"], .selling-plan-widget, [data-selling-plan]'
    );
    sellingPlanInputs.forEach(function (el) {
      var block = el.closest(".product-info__block") || el.closest(".product-block") || el.closest(".field");
      if (block) block.style.display = "none";
    });
  }

  function hideHeroButtons() {
    // Hide "Get Started" and "Take the Quiz" buttons in the hero section, keep "Talk to an Expert"
    const heroButtons = document.querySelectorAll(
      '.hero__buttons a, .hero__buttons button, [class*="hero"] a, [class*="hero"] button'
    );
    heroButtons.forEach(function (btn) {
      const text = (btn.textContent || "").trim().toUpperCase();
      if (
        text.includes("GET STARTED") ||
        text.includes("TAKE THE QUIZ") ||
        text.includes("TAKE OUR QUIZ")
      ) {
        btn.style.display = "none";
      }
    });
  }

  function hideExtraMainProductBlocks() {
    // In edit mode, the main-product section shows below the sliders.
    // Keep boosts visible but hide variant-picker, dietary info, price, share, etc.
    // We identify blocks by their content/class patterns.
    document.querySelectorAll('.product-info__block').forEach(function (block) {
      // Keep boost blocks visible
      if (block.hasAttribute('data-ch-boosts') || block.querySelector('[data-ch-boosts]') || block.classList.contains('custom-hydration-boosts') || block.classList.contains('custom-protein-boosts')) {
        return;
      }
      // Keep collapsible dietary info visible (optional, but useful for edit)
      // Hide variant picker
      if (block.querySelector('variant-picker')) {
        block.style.display = 'none';
        return;
      }
      // Hide price block
      if (block.classList.contains('product-info__block--price') || block.querySelector('.js-product-price')) {
        block.style.display = 'none';
        return;
      }
      // Hide buy-buttons block (we replace with Save)
      if (block.classList.contains('product-info__block--buy-buttons') || block.querySelector('[name="add"]') || block.querySelector('product-form')) {
        block.style.display = 'none';
        return;
      }
      // Hide share block
      if (block.querySelector('.share-buttons, [data-share]')) {
        block.style.display = 'none';
        return;
      }
      // Hide dividers between hidden sections
      if (block.children.length === 0 || (block.children.length === 1 && block.querySelector('hr, .divider'))) {
        block.style.display = 'none';
        return;
      }
    });
  }

  function replaceAddToCartWithSave() {
    // Already injected
    if (document.querySelector('.sf-edit-save-btn')) return;

    // Hide the original Add to Cart button wherever it is
    document.querySelectorAll('[name="add"], [data-add-to-cart], [data-add-to-cart-text], .product-form__submit').forEach(function (el) {
      el.style.display = "none";
    });
    // Hide dynamic checkout buttons
    document.querySelectorAll('.shopify-payment-button, [data-shopify="dynamic-checkout"]').forEach(function (el) {
      el.style.display = "none";
    });
    // Hide Save for Later link in edit mode (editing uses the Save button instead)
    document.querySelectorAll('[data-save-for-later]').forEach(function (el) {
      el.style.display = "none";
    });

    // Intercept form submissions to prevent add-to-cart
    var form = document.querySelector('#product-form, .js-product-form, form[action*="/cart/add"]');
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }

    // Create Save button
    var saveBtn = document.createElement("button");
    saveBtn.type = "button";
    saveBtn.className = "sf-edit-save-btn";
    saveBtn.textContent = "Save Formula";
    saveBtn.style.cssText = "display:block !important;visibility:visible !important;background:#2e7d32;color:#fff;font-weight:700;font-size:18px;padding:16px 40px;border:none;border-radius:8px;cursor:pointer;width:100%;max-width:400px;margin:32px auto;transition:background 0.2s;position:relative;z-index:10;";
    saveBtn.onmouseover = function () { saveBtn.style.background = "#1b5e20"; };
    saveBtn.onmouseout = function () { saveBtn.style.background = "#2e7d32"; };
    saveBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      saveEditedFormula(saveBtn);
    });

    // Insert after boosts + dietary info sections (inside main-product).
    // Block order: boosts → dietary info (collapsible) → name → subscribe → ...
    var inserted = false;

    // Strategy 1: Insert after the last visible block among boosts / dietary info
    // Find the boosts block and any collapsible/dietary blocks near it
    var boostsBlock = document.querySelector('[data-ch-boosts]');
    if (boostsBlock) {
      // Walk forward from boosts to find the last relevant sibling
      var insertAfter = boostsBlock;
      var next = boostsBlock.nextElementSibling;
      while (next) {
        // Keep going past dietary-info collapsibles and dividers
        if (next.querySelector('details-disclosure, details') ||
            next.tagName === 'HR' ||
            (next.children.length === 1 && next.querySelector('hr, .divider'))) {
          insertAfter = next;
          next = next.nextElementSibling;
        } else {
          break;
        }
      }
      insertAfter.insertAdjacentElement('afterend', saveBtn);
      inserted = true;
    }

    // Strategy 2: Append to sliders section
    if (!inserted) {
      var sliderSection = null;
      document.querySelectorAll('.shopify-section').forEach(function (sec) {
        var id = (sec.id || '').toLowerCase();
        if (id.includes('slider') || id.includes('hydration-slider') || id.includes('protein-slider')) {
          sliderSection = sec;
        }
      });
      if (sliderSection) {
        sliderSection.appendChild(saveBtn);
        inserted = true;
      }
    }

    // Strategy 3: Fallback to main content
    if (!inserted) {
      var main = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
      main.appendChild(saveBtn);
    }
  }

  function saveEditedFormula(btn) {
    btn.disabled = true;
    btn.textContent = "Saving...";

    // Gather current form state using FormulaUrlHash
    var config = {};
    if (window.FormulaUrlHash) {
      config = window.FormulaUrlHash.getConfigFromForm(pageType);
    }

    // Build the payload from the form state
    var payload = {
      mix_name: editableFormulaName,
      formula_type: pageType,
    };

    // Get flavor from the form
    var flavorRadio = document.querySelector(
      'input[name="properties[Flavor]"]:checked'
    );
    if (flavorRadio) payload.flavor = flavorRadio.value;

    // Get flavor intensity
    var flavorSlider = document.getElementById("flavor_slider");
    if (flavorSlider) payload.flavor_intensity = flavorSlider.value;

    // Get package size
    var pkgSize = "";
    var variantRadio = document.querySelector(
      'variant-picker input.js-option[type="radio"]:checked'
    );
    if (variantRadio) {
      var match = variantRadio.value.match(/(\d+)/);
      if (match) pkgSize = match[1];
    }
    if (!pkgSize) {
      var pkgSelect =
        document.querySelector('select[name="properties[Package Size]"]') ||
        document.getElementById("ch-package-size");
      if (pkgSelect) {
        var match2 = pkgSelect.value.match(/(\d+)/);
        if (match2) pkgSize = match2[1];
      }
    }
    payload.package_size = pkgSize;

    // Get protein type
    var proteinRadio = document.querySelector(
      'input[name="properties[Protein Type]"]:checked'
    );
    payload.selected_protein = proteinRadio ? proteinRadio.value : "";

    // Get slider values
    payload.sliders = {};
    if (pageType === "protein") {
      var ccSlider = document.getElementById("calorie_carbs_slider");
      if (ccSlider) payload.sliders.calories = ccSlider.value;
    } else {
      var sliderMap = {
        calories_slider: "calories",
        carbs_slider: "carbohydrates",
        electrolytes_slider: "electrolytes",
        protein_slider: "protein",
        aminoacids_slider: "bcaas",
        caffeine_slider: "caffeine",
      };
      for (var sliderId in sliderMap) {
        var slider = document.getElementById(sliderId);
        if (slider) payload.sliders[sliderMap[sliderId]] = slider.value;
      }
    }

    // Get boosts
    var boostCheckboxes = document.querySelectorAll(
      'input[name="boosts[]"]:checked'
    );
    var boostIds = [];
    var boostLabels = [];
    boostCheckboxes.forEach(function (cb) {
      boostIds.push(cb.value);
      // Prefer data-label attribute (set by boost renderer), then the <label> element text
      var labelText = cb.dataset.label || '';
      if (!labelText) {
        var labelEl = cb.id ? document.querySelector('label[for="' + cb.id + '"]') : null;
        if (labelEl) labelText = labelEl.textContent.trim();
      }
      if (labelText) boostLabels.push(labelText);
    });
    payload.boosts = {
      ids: boostIds,
      labels: boostLabels,
      ids_string: boostIds.join(","),
    };

    // Send update to API via form-encoded POST (App Proxy strips JSON bodies)
    var payloadJson = JSON.stringify(payload);
    var formData = new FormData();
    formData.set('id', formulaId);
    formData.set('payload_json', payloadJson);

    fetch("/apps/formulas/update", {
      method: "POST",
      body: formData,
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (resp) {
        return resp.json();
      })
      .then(function (data) {
        if (data.ok) {
          btn.textContent = "Saved!";
          btn.style.background = "#1b5e20";
          if (isAdminContext) {
            // Admin context: refresh the editor so it re-renders against the
            // just-persisted state. formula-url-hash.js keeps the URL hash in
            // sync with form state as the user edits, so reload() picks up the
            // same configuration that was saved. Avoids the manual-refresh
            // dance the CSRs hit (browser refresh kicks them back to the
            // admin home and they have to navigate back through Saved
            // Formulas to see their changes).
            setTimeout(function () {
              window.location.reload();
            }, 800);
          } else {
            // Customer context: redirect back to My Formulas
            setTimeout(function () {
              window.location.href = "/pages/saved-formulas";
            }, 1000);
          }
        } else {
          throw new Error(data.message || "Save failed");
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = "Save Formula";
        btn.style.background = "#2e7d32";
        alert("Save failed: " + err.message);
      });
  }
})();
